<div
  class="mt-6 flex w-[142px] justify-start gap-[12px] rounded-xl border-b border-l border-r border-b-gray-100 border-l-gray-100 border-r-gray-100 bg-white py-[6px] pl-[4px] pr-[6px] shadow-[2px_2px_4px_rgba(0,0,0,0.1),-2px_2px_4px_rgba(0,0,0,0.1)]">
  <button (click)="shareInstagram()">
    <ln-instagram-svg-icon
      (pointerenter)="updateSocialNetworks(SocialsNetworks.instagram)"
      (pointerleave)="updateSocialNetworks(null)"
      [class]="
        'h-[24px] w-[24px] cursor-pointer transition-transform duration-300 hover:scale-110'
      "></ln-instagram-svg-icon>
  </button>
  <button (click)="shareFacebook()">
    <ln-facebook-svg-icon
      (pointerenter)="updateSocialNetworks(SocialsNetworks.facebook)"
      (pointerleave)="updateSocialNetworks(null)"
      [class]="
        'h-[24px] w-[24px] cursor-pointer transition-transform duration-300 hover:scale-110'
      "></ln-facebook-svg-icon>
  </button>
  <button (click)="shareWhatsapp()">
    <ln-whatsapp-svg-icon
      (pointerenter)="updateSocialNetworks(SocialsNetworks.whatsapp)"
      (pointerleave)="updateSocialNetworks(null)"
      [class]="
        'h-[24px] w-[24px] cursor-pointer transition-transform duration-300 hover:scale-110'
      "></ln-whatsapp-svg-icon>
  </button>
  <button (click)="shareLinkedIn()">
    <ln-linkedin-svg-icon
      (pointerenter)="updateSocialNetworks(SocialsNetworks.linkedin)"
      (pointerleave)="updateSocialNetworks(null)"
      [class]="
        'h-[24px] w-[24px] cursor-pointer transition-transform duration-300 hover:scale-110'
      "></ln-linkedin-svg-icon>
  </button>
  @if (socialNetworkSelected()) {
    <span class="absolute bottom-0 right-0 translate-x-[4px] translate-y-[20px]">
      <div
        class="h-[16px] rounded-md bg-beige pl-[7px] pr-[6px] text-xs font-normal text-cafe shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
        @if (socialNetworkSelected()! === SocialsNetworks.linkedin) {
          {{ 'labels.linkCopy' | transloco }}
        } @else {
          {{ 'labels.shareOn' | transloco }} {{ socialNetworkSelected()! }}
        }
      </div>
    </span>
  }
  @if (showLinkCopied()) {
<!--    class="absolute bottom-[-22px] right-0 translate-x-[4px] translate-y-[20px]"-->
    <span [ngClass]="[currentScreenSize() === 'SM' ? 'bottom-0' : 'bottom-[-22px]', 'absolute right-0 translate-x-[4px] translate-y-[20px]']">
      <div
        class="flex h-[18px] flex-col justify-center rounded-md bg-amarillo pl-[7px] pr-[6px] text-xs font-normal text-cafe shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
        {{ 'labels.linkCopied' | transloco }}
      </div>
    </span>
  }
</div>
